<div>
  <div class="ui-fluid">
    <p-table #dt
             [value]="model.rows"
             [globalFilterFields]="filterableColumnKeys"
             selectionMode="single"
             [loading]="false"
             [loadingIcon]="null"
             [showLoader]="false"
             [lazy]="true"
             (onLazyLoad)="lazyLoad($event)"
             [paginator]="false"
             [rows]="rows"
             [totalRecords]="rowCount"
             (onRowSelect)="rowChangePreview($event.data?.guid)"
             class="table-layout-fixed">
      <ng-template pTemplate="header">
        <tr class="order-list-header">
          <th id="location-list-key" [attr.width]="rowTools.width" [style.min-width.px]="rowTools.width"></th>
          <th id="location-list-name" *ngFor="let col of visibleColumns" [pSortableColumn]="col.sortable ? col.key : null" [attr.width]="col.width" [style.min-width.px]="col.width">
            <table>
              <tbody>
                <tr>
                  <td style="width:22px">
                    <p-sortIconCustom *ngIf="col.sortable === true" [field]="col.key"></p-sortIconCustom>
                  </td>
                  <td>
                    {{col.name}}
                  </td>
                </tr>
              </tbody>
            </table>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="loadingbody" let-columns>
        <tr>
          <td [attr.colspan]="numColumns" style="text-align: center">
            <loading></loading>Loading...
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="numColumns" style="text-align: center">
            No records found
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr [pSelectableRow]="item" (mouseenter)="hover = item.id" (mouseleave)="hover = null">
          <td>
            <row-tools [tools]="rowTools" [item]="item" (onClick)="clickRowTools($event)"  [visible]="hover == item.id"></row-tools>
          </td>
          <td *ngFor="let col of visibleColumns">
            <dynamic-value [data]="item" [column]="col"></dynamic-value>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <paginator-custom [rows]="dt.rows" [totalRecords]="dt.totalRecords" (onPageChange)="lazyLoad($event)"></paginator-custom>
  </div>
  <p-dialog [(visible)]="showModal" [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%',boxShadow:'none'}" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
    <location-form *ngIf="showModal" [id]="selection?.guid" (onCancel)="cancel($event)" (onSaveComplete)="complete()"></location-form>
  </p-dialog>
  <p-dialog [(visible)]="showUserModal" [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%',boxShadow:'none'}" [modal]="true" [showHeader]="false" [closable]="false">
    <user-form *ngIf="showUserModal" [id]="null" (onCancel)="cancel($event)" (onSaveComplete)="cancel($event);"></user-form>
  </p-dialog>
  <p-dialog  #orderDialog [(visible)]="showOrderModal" [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%',boxShadow:'none'}" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
    <order-form *ngIf="showOrderModal" [dialog]="dialogRef" [id]="null" (onCancel)="cancel($event)" (onSaveComplete)="cancel($event);" [navigateOnSave]="false"></order-form>
  </p-dialog>
  <p-dialog [(visible)]="isDeleting" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false" [closable]="false">
    <div class="modal-body-custom">
      Are you sure you want to delete {{selection?.fullName}}?
    </div>
    <div class="ui-dialog ui-dialog-footer">
      <div class="modal-footer-custom">
        <div class="link-button d-inline-block">
          <a class="muted7" (click)="cancelDelete()">Cancel</a>
        </div>
        <div class="link-button float-right d-inline-block">
          <button class="link-button" type="submit" (click)="delete()">Delete</button>
        </div>
      </div>
    </div>
  </p-dialog>
</div>

